var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-end justify-center"},[_c('button',{staticClass:"btn btn-primary rw-bg-3 border-0 d-flex items-center gap-2 btn-sm",attrs:{"type":"button"},on:{"click":_vm.onContinue}},[_c('span',{staticClass:"material-symbols-outlined"},[_vm._v("comment")]),_c('span',[_vm._v(" Lanjutkan Chat")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }